import React, { useState, useEffect } from 'react';

import { useMenu } from '~/hooks/menu';

import { Content } from './styles';

const Container: React.FC = ({ children }) => {
  const [minH, setMinH] = useState(0);

  const { visible } = useMenu();

  useEffect(() => {
    setTimeout(() => {
      const { innerHeight: height } = window;
      if (height) {
        setMinH(height);
      }
    }, 1000);
  }, []);

  return (
    <Content minH={minH} className={visible ? 'menu-visible' : 'menu-closed'}>
      <>{children}</>
    </Content>
  );
};

export default Container;
